module.exports = __webpack_public_path__ + "static/media/fb_logo.8f7f8c49.png";